import { createReducer, on } from '@ngrx/store';
import { FeatureFlagActions } from './feature-flags.actions';
import { FeatureFlagState } from './feature-flags.store';

const initialState: FeatureFlagState = {
  flags: undefined,
};
export const featureFlagReducer = createReducer(
  initialState,
  on(FeatureFlagActions.setAllFeatureFlags, (state, action) => {
    const newState: FeatureFlagState = {
      ...state,
      flags: action.featureFlags,
    };
    return newState;
  }),
);
